module.exports = __webpack_public_path__ + "img/3.75a075f6.png";